// extracted by mini-css-extract-plugin
export default {"content":"staffRegister_content__3sW-e"};